import React from "react";
import Tooltip from "components/Tooltip";
import classes from "./styles.module.scss";
import CloseIcon from "assets/images/icons/JSX/Close";

const FloatingCloseButton = ({
    tooltipId = "floating_close_button",
    tooltipText = "Close",
    handleClose = () => {},
}) => {
    return (
        <div
            className={classes.floatingCloseButton}
            onClick={handleClose}
            data-tip={tooltipText}
            data-for={tooltipId}
        >
            <CloseIcon />
            <Tooltip id={tooltipId} />
        </div>
    );
};

export default FloatingCloseButton;